/* eslint-disable */

import styled, { css } from 'styled-components';
import vjs from './assets/vjs';

export default styled.div`
  overflow: hidden;
  width: 100%;
  height: 100vh;
  margin: 0;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  .secondsWrapper {
    position: fixed;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 99999999;
    color: rgba(255,255,255,.4);
    display: table;
    > * {
      text-shadow: 0 0 1rem rgba(0,0,0,.4);
    }
    &.right {
      right: 2rem;
      > * {
        float: right;
      }
    }
    &.left {
      left: 2rem;
      > * {
        float: left;
      }
    }
    > h3 {
      font-size: 5rem;
      margin: 4.3rem 2rem 0;
    }
    > i {
      color: rgba(255,255,255,.4);
      font-size: 10rem;
    }
  }
  .currentTime {
    position: fixed;
    top: 0;
    font-size: 6rem;
    left: 0;
    right: 0;
    display: table;
    color: rgba(255,255,255,.4);
    z-index: 99999999;
    text-align: center;
    width: 100%;
  }
  .progressPoint {
    transition: width .1s ease-out,height .1s ease-out;
    top: -.15rem;
    border: 0;
    width: 1em;
    height: 1em;
    border-radius: 50%;
    z-index: 2;
    position: absolute;
    right: -.95rem;
    &:hover, &.active-item {
      outline: .8rem solid rgba(255,255,255,.8);
      outline-offset: .7rem;
    }
  }
  & > .playerWrapper {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 1;
    width: 100%;
    height: 100%;
    z-index: 10;
    overflow: hidden;
    box-sizing: border-box;
  }
  .backButtonWrapper {
    left: 3rem;
    position: fixed;
    z-index: 99999;
    top: 3rem;
    & > .titleWrapper {
      float: left;
      color: #fff;
      & > h3 {
        padding: 0;
        text-align: left;
        font-family: "IRANSans", sans-serif, serif !important;
        text-shadow: 0 0 1rem rgba(0,0,0,.4);
        &.faTitle {
          font-weight: normal;
          margin: -.1rem 1rem .2rem;
          font-size: 2.5rem;
        }
        &.enTitle {
          font-size: 1.7rem;
          margin: .8rem 0 0 .6em;
        }
      }
    }
    .backButton {
      cursor: pointer;
      float: left;
      border: .3rem solid #fff;
      border-radius: 8rem;
      width: 5rem;
      height: 5rem;
      overflow: hidden;
      text-align: center;
      display: inline-block;
      margin: 0 .8rem;
      background: transparent;
      outline: none;
      padding: 0;
      box-sizing: border-box;
      background-color: rgba(38,38,38,0.9);
      & i.fa {
        color: #fff;
        display: block;
        line-height: 0;
        font-size: 3rem;
      }
      &:hover, &.active-item {
        border: .3rem solid #ea1d5d;
        background: #fff;
        & > i.fa {
          color: #020100;
        }
      }
      &:hover {
        background: #fff;
        & > i.fa {
          color: #020100;
        }
      }
    }
  }
  & > #pageWrapper {
    background-repeat: no-repeat;
    background-position: center center;
    background-size: auto 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 1;
    width: 100%;
    height: 100vh;
    z-index: 5;
    overflow: hidden;
    box-sizing: border-box;
    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.4);
    }
    & > .content {
      overflow: hidden;
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      display: table;
      width: 100%;
      & > .playerControlsWrapper {
        color: #fff;
        & .playButton {
          cursor: pointer;
          border-radius: 5rem;
          border: none;
          overflow: hidden;
          box-sizing: border-box;
          background: rgba(255,255,255,.3);
          outline: none;
          width: 10rem;
          height: 10rem;
          font-size: 1.2rem;
          text-align: center;
          color: #fff;
          margin: 0 auto;
          display: inherit;
          text-align: center;
          &.activeItem, &:hover {
            border: .45rem solid #ea1d5d;
            background: #fff;
            color: #000;
            & > img {
              &.black {
                display: block;
              }
              &.white {
                display: none;
              }
            }
          }
          &:hover {
            background: #fff;
            color: #000;
          }
          & > img {
            width: 4rem;
            margin: .6rem auto;
            text-align: center;
            display: block;
            &.black {
              display: none;
            }
          }
        }
      }
    }
  }
  ${vjs()}
  .video-title {
    font-family: "IRANSans", sans-serif, Serif;
    position: fixed;
    top: 0;
    width: 100%;
    text-align: center;
    transition: visibility 250ms ease, opacity 250ms ease;
    padding: 4rem 0;
    margin: 0;
    color: #fff;
    pointer-events: none;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 40rem;
      z-index: -1;
      background: linear-gradient(180deg,rgba(0,0,0,.79),rgba(0,0,0,.21) 26%,transparent 44%,transparent);
      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#c9000000",endColorstr="#00000000",GradientType=0);
    }
  }
  .vjs-has-started.vjs-user-inactive.vjs-playing .video-title {
    visibility: hidden;
    opacity: 0;
  }
  .action-button {
    background: none;
    border: none;
    color: #fff;
    cursor: pointer;
    margin: 0 5px;
    font-size: 20px;
    transition: all 0.3s ease;
    outline: none;
    width: 4.8rem;
    height: 4.8rem;
    border-radius: 50%;
    border: 0.5rem solid transparent;

    &.active-item {
      border: 0.5rem solid rgb(234, 29, 93) !important
    }

    &.liked {
      color: #4cd137;
      &:hover {
        color: #44bd32;
      }
    }

    &.disliked {
      color: #e84118;
      &:hover {
        color: #c23616;
      }
    }

    i {
      font-size: 3rem;
      margin-left: -1px;
    }
  }
`;
